<script setup lang="ts">
import { apiMessages } from '../../api/message-api';
import { Regions } from '../../types/error';
import { apiFetchErrorRegions } from '../../api/regions';
import { onMounted, onUnmounted, ref } from 'vue';

let message: any = ref({});
let regionsDropdown = ref([] as Regions);
const show = ref(false);

const regionBlurClick = (e: Event) => {
  const dropDownButton = document.querySelector('.platmap-error__btn');
  const dropDownMenu = document.querySelector('.dropdown-menu');
  if (
    dropDownMenu &&
    !dropDownMenu.contains(e.target as Node) &&
    dropDownButton &&
    !dropDownButton.contains(e.target as Node)
  ) {
    show.value = false;
  }
};

const loadMessages = async () => {
  const { messages } = await apiMessages('404Page');
  message.value = messages;
};

const loadRegions = async () => {
  const { regions } = await apiFetchErrorRegions();
  regionsDropdown.value = regions;
}

const showListHandler = () => {
  show.value = !show.value;
}

onMounted(async () => {
  await loadMessages();
  await loadRegions();
  document.addEventListener('click', regionBlurClick)
});

onUnmounted(() => {
  document.removeEventListener('click', regionBlurClick)
});

</script>

<template>
  <section class=" platmap-error">
    <div class="platmap-error__container">
      <h1 class="platmap-error__heading">{{ message.errorName }}</h1>
      <h2 class="platmap-error__subheading">{{ message.errorMessage }}</h2>
      <p class="platmap-error__para">{{ message.errorParaOne }}</p>
      <p class="platmap-error__para">{{ message.errorParaTwo }}</p>
      <p class="platmap-error__para last">{{ message.errorParaThree }}</p>
      <div class="platmap-error__regionbtn">
        <button class="platmap-error__btn btn" @click="showListHandler">
          {{ message.chooseRegion }}
          <i class="caret-down">
            <svg role="img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"
              :class="[{ 'moveDown': !show }]">
              <path fill="currentColor"
                d="M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z">
              </path>
            </svg>
          </i>
        </button>
        <ul class="dropdown-menu" :class="show ? 'show' : ''" role="menu">
          <li v-for="(region, index) in regionsDropdown" :key="index">
            <a role="menuitem" tabindex="50" :href="region.link">
              {{ region.name }}</a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.platmap-error {
  padding-inline: 25px;
  padding-block: 40px;
  max-height: 100vh;
  height: 100vh;
  overflow-y: auto;
  position: relative;

  @include mobile-standard {
    padding-bottom: 150px;
  }

  &__container {
    max-width: 1000px;
    margin-inline: auto;
  }

  &__heading {
    color: #00462E;
    font-size: 36px;
    margin-top: 19px;
    margin-bottom: 10px;
    font-weight: 500;
    text-align: center;

    @include mobile-standard {
      margin-top: 10px;
      margin-bottom: 8px;
    }
  }

  &__subheading {
    color: $light-green;
    font-size: 30px;
    margin-block: 20px;
    text-align: center;
    font-weight: 500;

    @include mobile-standard {
      margin-top: 8px;
      margin-bottom: 48px;
    }
  }

  &__para {
    margin-block: 15px;
    color: #5D5D5D;

    &.last {
      margin-top: 40px;
    }
  }

  &__btn {
    font-size: 14px;
    min-height: 38px;
    max-height: 38px;
    min-width: 282px;
    padding: 5.5px 12px;
    text-align: left;
    justify-content: flex-start;
    background-color: $light-green;
  }

  .caret-down {
    display: inline-flex;
    margin-left: 10px;
    width: 12px;
  }

  .dropdown-menu {
    border: none;
    margin-top: 4px;
    background: $light-green;
    border-radius: 3px;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.75);
    white-space: nowrap;
    width: 100%;
    position: relative;
    display: none;

    &.show {
      display: block;
    }

    li:first-child:hover:before {
      display: block;
      content: '';
      border: 10px solid transparent;
      border-bottom-color: #fec10d;
      position: absolute;
      left: 47%;
      top: -19px;
      transform: translateX(-50%);
    }

    &:before {
      display: block;
      content: '';
      border: 10px solid transparent;
      border-bottom-color: $light-green;
      position: absolute;
      left: 47%;
      top: -19px;
      transform: translateX(-50%);
    }

    a {
      line-height: 33px;
      display: block;
      padding: 3px 20px;
      font-weight: 400;
      color: $white;
      border-bottom: 1px solid #fff;
      text-decoration: none;

      &:focus {
        outline: dotted thin;
        outline: -webkit-focus-ring-color auto 5px;
        outline-offset: -2px;
      }

      &:focus,
      &:hover {
        color: #262626;
        background-color: #fec10d;
      }
    }
  }

  &__regionbtn {
    max-width: 282px;
    margin: 40px auto 0;
  }

  .moveDown {
    transform: scaleY(-1);
  }
}
</style>